// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"3c8633d6","453":"aedb7686","580":"2170a1e7","933":"3378f81f","970":"2fd1d9a1"}[chunkId] + ".chunk.js";
};